const awsmobile = {
  Auth: {
    region: "us-east-1",
    userPoolId: "us-east-1_WaXM8s7MS",
    userPoolWebClientId: "a8mimve3r00hvsi1mnh9nv04l"
  }
};

export default awsmobile;